import 'element-plus/es/components/badge/style/index';
import '@baidu/trade-ui/styles/src/bms-user-menu.styl';
//# sourceMappingURL=index.js.map
